import { Button, message } from 'antd';
import React, { FC, useCallback, useState } from 'react';
import { downloadInvoicePDF } from '../../thunks/invoices_thunks';
import { withUserType } from '../withUserType';
import { connect } from 'react-redux';

const GenerateInvoicePdfButton: FC<any> = ({
	userType,
	currentUser,
	invoice,
}): React.ReactElement => {
	const [generatingPDF, setGeneratingPDF] = useState(false);

	const generateInvoicePDF = useCallback(
		(id) => {
			setGeneratingPDF(true);
			downloadInvoicePDF(id, userType, currentUser, invoice)
				.catch(() => {
					message.error('An error occurred in downloading the invoice. Please try again!');
				})
				.finally(() => {
					setGeneratingPDF(false);
				});
		},
		[userType, currentUser, invoice]
	);

	return (
		<p style={{ marginBottom: 0, marginTop: 0 }}>
			Don't have an invoice file?{' '}
			<Button
				loading={generatingPDF}
				type="link"
				onClick={() => generateInvoicePDF(invoice.id)}
				style={{ marginBottom: 0, marginTop: 0 }}
			>
				Generate PDF
			</Button>
		</p>
	);
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
});

export default withUserType(connect(mapStateToProps)(GenerateInvoicePdfButton));
